// Permet de déconnecter l'ultilisateur et de le rediriger vers la page connexion lorsque le token a expiré
export const removeToken = (res, history) => {
  if (res.status === 401) {
    console.log(res.message);
    console.log(res, 'RES');
    localStorage.removeItem('token');
    history.replace('/');
  }
};

/**
 * Vérifie si le libellé est encodé au format utf-8 ou non
 * S'il n'est pas encodé au format utf-8 on l'encode grâce à notre fonction
 * Si non on l'affiche tel quel
 *  */
export const checkUTF8 = (libelle) => {
  let isUTF8 = false;
  let libToUTF8 = libelle;
  try {
    // Try to convert to utf-8
    libToUTF8 = decodeURIComponent(escape(libelle));
  } catch (e) {
    isUTF8 = true;
  }

  if (isUTF8) {
    return libelle;
  }

  return libToUTF8;
};

export const getIdRessource = (data) => {
  const idResources = data.map((resource, index) => {
    const { idRessource, title } = resource;
    const value = index;

    return { value, title: idRessource, libelle: title };
  });

  return idResources;
};

export const getLibRessource = (data, idRessource) => {
  const allResources = getIdRessource(data);
  const resources = allResources.find(
    (resource) => resource.title === idRessource
  );

  return resources?.libelle;
};

export const getCategorieAffectation = () => [
  { value: 'transferable', title: 'transferable' },
  { value: 'non-transferable', title: 'non transferable' },
];

export const getTypeAffectation = () => [
  { value: '1', title: 'INDIV' },
  { value: '2', title: 'ETABL' },
];

export const getPublicCible = () => [
  { value: '1', title: 'ELEVE' },
  { value: '2', title: 'ENSEIGNANT' },
  { value: '3', title: 'DOCUMENTALISTE' },
  { value: '4', title: 'AUTRE PERSONNEL' },
];
